import { useNavigate, useParams } from "react-router-dom";
import MainContainer from "../../layout/MainContainer";
import {
  Box,
  Tabs,
  Tab,
  TextField,
  Button,
  CardMedia,
  Input,
  MenuItem,
  Select,
  SelectChangeEvent,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useFormik } from "formik";
import * as Yup from "yup";
import React, { ChangeEvent, useEffect, useState } from "react";
import "react-phone-input-2/lib/bootstrap.css";
import AddIcon from "@mui/icons-material/Add";
import PhoneInput from "react-phone-input-2";
import {
  useLazyGetEmployerByIdQuery,
  useUpdateEmployerMutation,
} from "../../services/users";
import { Employer } from "../../types/General";
import { showError, showToast } from "../../constants/toasts";
import { UploadMedia } from "../../utils/mediaUpload";
import { isString, isValidInput } from "../../utils/validations";
import useTranslation from "../../hooks/traslation";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <>{children}</>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const AddCustomer = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const transation = useTranslation();
  const [getDataById] = useLazyGetEmployerByIdQuery();
  const [updateEmployer] = useUpdateEmployerMutation();

  const [valueTabs, setValueTabs] = useState(0);
  const [loading, setLoading] = useState(false);
  const [detail, setDetail] = useState<Employer | null>(null);
  const handleChangeTabs = (event: React.SyntheticEvent, newValue: number) => {
    setValueTabs(newValue);
  };

  const [alertMessage, setAlertMessage] = useState("");
  const [profileImage, setProfileImage] = useState("");
  const [showAlert, setShowAlert] = useState(false);
  const [alertType, setAlertType] = useState(0);
  const [image, setImage] = useState<string>("");
  const [fileName, setFileName] = useState<string>("");
  const [selectedCountry, setSelectedCountry] = useState("");
  const [phone, setPhone] = useState("");
  const [dialCode, setDialCode] = useState("+971");
  const [error, setError] = useState(false);

  const handleChangeCountry = (event: any) => {
    setSelectedCountry(event.target.value);
  };

  const handleChangePhone = (phone: any, country: any) => {
    setPhone(phone?.replace(country.dialCode, ""));
    setDialCode(country?.dialCode);
  };
  const [selectField1, setSelectField1] = React.useState("default");
  const handleChange1 = (event: SelectChangeEvent) => {
    setSelectField1(event.target.value as string);
  };
  const handleNextTab = () => {
    setValueTabs((prevIndex) => prevIndex + 1); // Move to the next tab
  };

  const formik = useFormik({
    enableReinitialize: true,

    initialValues: {
      name: detail?.firstName || "",
      lastName: detail?.lastName || "",
      address: detail?.address || "",
      email: detail?.email || "",
    },

    validationSchema: Yup.object({
      name: Yup.string()
        .required("This field is required")
        .min(2, "Minimum 2 characters are required"),
      email: Yup.string()
        .required("Email is required!")
        .matches(
          /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i,
          "Please enter a valid email address!"
        ),
    }),
    onSubmit: async (values: any) => {
      formik.setSubmitting(true);
      if (phone.length < 5) return;
      let body = {
        ...(profileImage ? { image: profileImage } : {}),
        firstName: values?.name || "",
        lastName: values?.lastName || "",
        phoneNo: phone || "",
        email: values?.email || "",
        // address: values?.address || "",
        // city: values?.city || "",
        // latitude: 0,
        // longitude: 0,
        dialCode: (dialCode.includes("+") ? "" : "+") + dialCode,
        // country: selectedCountry || "",
        // ...(id ? { userId: id } : {}),
        // ...(!id ? { role: ROLES.USER } : {}),
      };
      

      try {
        let response;
        if (id) {
          // If ID exists, update customer
          response = await updateEmployer({ id, body }).unwrap();
        }
        if (response?.statusCode === 200) {
          // setUserId(response?.data?._id || "");
          showToast(
            id ? "Employer updated successfully" : "Employer added successfully"
          );
          navigate("/manage-employers");
        }
      } catch (error: any) {
        showError(error?.data?.message || "");
        console.log(error);
      }
    },
  });

  const handleProfileUpload = async (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const files = event.target.files;
    const file = files?.length ? files[0] : null;

    if (!file) {
      setProfileImage("");
      return;
    }
    if (
      file &&
      file.type &&
      file.type !== "image/jpeg" &&
      file.type !== "image/jpg" &&
      file.type !== "image/png"
    ) {
      showError("Please upload the image in the JPG, JPEG or PNG format");
      return;
    }

    const imageUrl = (await UploadMedia(file)) as any;
    if (imageUrl?.data) {
      setProfileImage(imageUrl?.data?.image || "");
    }
  };

  useEffect(() => {
    if (detail?.phoneNo) {
      setPhone(detail?.phoneNo || "");
      setProfileImage(detail?.image || "");
      setDialCode(detail?.dialCode || "");
    }
  }, [detail]);

  const getData = async (id: string) => {
    setLoading(true);
    try {
      const response = await getDataById({
        id,
      }).unwrap();
      setLoading(false);

      if (response?.statusCode === 200) {
        setDetail(response?.data?.user || null);
      }
    } catch (error: any) {
      showError(error?.data?.message || "");
      setLoading(false);
    }
  };

  useEffect(() => {
    if (id) {
      getData(id);
    }
  }, []);

  return (
    <MainContainer>
      <div className="main_title">
        <h1>{id ? transation.main.editEmployer : "Add Employer"} </h1>
        <p>
          <span onClick={() => navigate("/dashboard")}>
            {transation.dashboard.dashboard}
          </span>{" "}
          -{" "}
          <span onClick={() => navigate("/manage-employers")}>
            {transation.main.ManageEmployer}
          </span>{" "}
          - {id ? transation.main.editEmployer : "Add Employer"}
        </p>
      </div>

      {/* <div className="table_header">
        <div className="left_s">
          <Box className="custom_tabs1" sx={{ width: "100%" }}>
            <Tabs
              value={valueTabs}
              onChange={handleChangeTabs}
              aria-label="basic tabs example"
              className="custom_tabs_links"
            >
              <Tab label="Personal Details" {...a11yProps(0)} />
              <Tab label="Property Details" {...a11yProps(1)} />
              <Tab label="Passport" {...a11yProps(2)} />
            </Tabs>
          </Box>
        </div>
      </div> */}

      <div className="cards">
        <CustomTabPanel value={valueTabs} index={0}>
          <form className="form" onSubmit={formik.handleSubmit}>
            <div className="gap_p">
              <div className="control_group w_100">
                <label>{transation.main.uploadImage}</label>
                {profileImage ? (
                  <div className="upload_image">
                    <div className="upload_image_holder">
                      <figure>
                        <CardMedia
                          component="img"
                          image={
                            profileImage
                              ? profileImage
                              : "/static/images/user_placeholder.png"
                          }
                          alt="photo"
                        />
                      </figure>
                      <CloseIcon
                        onClick={() => {
                          setProfileImage("");
                        }}
                      />
                    </div>
                  </div>
                ) : (
                  <label className="upload_image" htmlFor="icon-button-file">
                    <Input
                      sx={{ display: "none" }}
                      id="icon-button-file"
                      type="file"
                      inputProps={{
                        accept: "image/png,image/jpeg,image/jpg",
                      }}
                      onChange={(e: any) => {
                        handleProfileUpload(e);
                        e.target.value = null;
                      }}
                    />
                    <span className="upload_image_holder">
                      <figure className="add_img">
                        <img
                          src="/static/images/user_placeholder.png"
                          alt="icon"
                        />
                        <span className="upload_img_icon">
                          <img src="/static/images/edit2_icon.svg" alt="icon" />
                        </span>
                      </figure>
                    </span>
                  </label>
                )}
              </div>
              <div className="control_group w_50">
                <label>{transation.main.firstName}</label>
                <TextField
                  placeholder={transation.main.firstName}
                  variant="outlined"
                  className="text_field"
                  fullWidth
                  hiddenLabel
                  name="name"
                  id="name"
                  inputProps={{ maxLength: 40 }}
                  value={formik.values.name}
                  onChange={(val) => {
                    if (
                      isValidInput(val.target.value) &&
                      isString(val.target.value)
                    ) {
                      formik.handleChange(val);
                    }
                  }}
                  onBlur={formik.handleBlur}
                  helperText={formik.touched.name && formik.errors.name}
                />
              </div>

              <div className="control_group w_50">
                <label>{transation.main.lastName}</label>
                <TextField
                  placeholder={transation.main.lastName}
                  variant="outlined"
                  className="text_field"
                  fullWidth
                  hiddenLabel
                  name="lastName"
                  id="lastName"
                  inputProps={{ maxLength: 40 }}
                  value={formik.values.lastName}
                  onChange={(val) => {
                    if (
                      isValidInput(val.target.value) &&
                      isString(val.target.value)
                    ) {
                      formik.handleChange(val);
                    }
                  }}
                  onBlur={formik.handleBlur}
                  // helperText={formik.touched.lastName && formik.errors.lastName}
                />
              </div>

              <div className="control_group w_50">
                <label>{transation.main.email}</label>
                <TextField
                  placeholder={transation.main.email}
                  hiddenLabel
                  fullWidth
                  className="text_field"
                  name="email"
                  id="email"
                  inputProps={{ maxLength: 80 }}
                  value={formik.values.email}
                  onChange={(val) => {
                    if (val.target.value === " " || val.target.value === ".") {
                    } else {
                      formik.handleChange(val);
                    }
                  }}
                  onBlur={formik.handleBlur}
                  helperText={formik.touched.email && formik.errors.email}
                />
              </div>

              <div className="control_group w_50">
                <label>{transation.main.phone}</label>
                <PhoneInput
                  enableSearch
                  value={dialCode + phone}
                  country={"uae"}
                  inputClass="phoneInput"
                  onChange={(phone, country) =>
                    handleChangePhone(phone, country)
                  }
                  inputStyle={{ width: "100%" }}
                  buttonClass="phoneBtn"
                  placeholder={transation.main.phone}
                />
                {!phone && error ? (
                  <h6 className="err_msg">{transation.error.required}</h6>
                ) : (
                  ""
                )}
                {phone.length >= 1 && phone.length < 5 && error ? (
                  <h6 className="err_msg">{transation.error.validphone}</h6>
                ) : (
                  ""
                )}
              </div>
              {/* <div className="control_group w_50" style={{ marginTop: "1px" }}>
                <label>Address</label>
                <TextField
                  placeholder="Enter Address"
                  hiddenLabel
                  fullWidth
                ></TextField>
              </div> */}
              {/* <div className="control_group w_25">
                <label>City</label>
                <TextField placeholder="Enter City" hiddenLabel fullWidth></TextField>
              </div>
              <div className="control_group w_25">
                <label>State</label>
                <TextField placeholder="Enter State" hiddenLabel fullWidth></TextField>
              </div>
              <div className="control_group w_25">
                <label>Country</label>
                <TextField placeholder="Enter Country" hiddenLabel fullWidth></TextField>
              </div>
              <div className="control_group w_25">
                <label>Zip Code</label>
                <TextField placeholder="Enter State" hiddenLabel fullWidth></TextField>
              </div> */}
            </div>
            <div className="form_btn">
              <Button
                className="btn btn_primary"
                type="submit"
                onClick={() => setError(true)}
                // onClick={() => navigate("/manage-employers")}
              >
                {transation.globals.submit}
              </Button>
            </div>
          </form>
        </CustomTabPanel>
        <CustomTabPanel value={valueTabs} index={1}>
          <div className="form">
            <div className="borderBox">
              <IconButton className="remove_icon">
                <CloseIcon />
              </IconButton>
              <div className="gap_p">
                <div className="control_group w_50">
                  <label>Property Name</label>
                  <TextField
                    placeholder="Enter Property Name"
                    hiddenLabel
                    fullWidth
                  ></TextField>
                </div>
                <div className="control_group w_50">
                  <label>Property</label>
                  <Select
                    fullWidth
                    labelId="country_to"
                    id="country_to"
                    value={selectField1}
                    onChange={handleChange1}
                  >
                    <MenuItem disabled value="default">
                      Select Property
                    </MenuItem>
                    <MenuItem value={10}>Home</MenuItem>
                    <MenuItem value={20}>Villa</MenuItem>
                    <MenuItem value={30}>Apartment</MenuItem>
                    <MenuItem value={40}>Building</MenuItem>
                  </Select>
                </div>
                <div className="control_group w_50">
                  <label>Address</label>
                  <TextField
                    placeholder="Enter Address"
                    hiddenLabel
                    fullWidth
                  ></TextField>
                </div>
                <div className="control_group w_50">
                  <label>City</label>
                  <TextField
                    placeholder="Enter City"
                    hiddenLabel
                    fullWidth
                  ></TextField>
                </div>
              </div>
            </div>
            <div className="borderBox">
              <IconButton className="remove_icon">
                <CloseIcon />
              </IconButton>
              <div className="gap_p">
                <div className="control_group w_50">
                  <label>Property Name</label>
                  <TextField
                    placeholder="Enter Property Name"
                    hiddenLabel
                    fullWidth
                  ></TextField>
                </div>
                <div className="control_group w_50">
                  <label>Property</label>
                  <Select
                    fullWidth
                    labelId="country_to"
                    id="country_to"
                    value={selectField1}
                    onChange={handleChange1}
                  >
                    <MenuItem disabled value="default">
                      Select Property
                    </MenuItem>
                    <MenuItem value={10}>Home</MenuItem>
                    <MenuItem value={20}>Villa</MenuItem>
                    <MenuItem value={30}>Apartment</MenuItem>
                    <MenuItem value={40}>Building</MenuItem>
                  </Select>
                </div>
                <div className="control_group w_50">
                  <label>Address</label>
                  <TextField
                    placeholder="Enter Address"
                    hiddenLabel
                    fullWidth
                  ></TextField>
                </div>
                <div className="control_group w_50">
                  <label>City</label>
                  <TextField
                    placeholder="Enter City"
                    hiddenLabel
                    fullWidth
                  ></TextField>
                </div>
              </div>
            </div>
            <p className="link_text end">
              <span className="c_primary">
                <AddIcon /> Add more properties
              </span>
            </p>
            <div className="form_btn">
              <Button className="btn btn_primary" onClick={handleNextTab}>
                Next
              </Button>
            </div>
          </div>
        </CustomTabPanel>
        <CustomTabPanel value={valueTabs} index={2}>
          <div className="form">
            <div className="gap_p">
              <div className="control_group w_100">
                <label>Expiry Date</label>
                <TextField
                  placeholder="Enter Expiry Date"
                  hiddenLabel
                  fullWidth
                ></TextField>
              </div>
              <div className="control_group w_33">
                <label>Upload Front Image</label>
                {image ? (
                  <div className="upload_image no_radius v2">
                    <div className="upload_image_holder">
                      <figure>
                        <CardMedia component="img" image={image} alt="photo" />
                      </figure>
                      <CloseIcon
                        onClick={() => {
                          setImage("");
                          setFileName("");
                        }}
                      />
                    </div>
                  </div>
                ) : (
                  <label
                    className="upload_image no_radius v2"
                    htmlFor="icon-button-file"
                  >
                    <Input
                      sx={{ display: "none" }}
                      id="icon-button-file"
                      type="file"
                      inputProps={{
                        accept: "image/png,image/jpeg",
                      }}
                      onChange={(event: ChangeEvent<HTMLInputElement>) => {
                        const files = (event.target as HTMLInputElement).files;
                        if (files && files[0].type.includes("image")) {
                          setFileName(files[0].name);
                          setImage(URL.createObjectURL(files[0]));
                        } else {
                          setAlertType(0);
                          setShowAlert(true);
                          setAlertMessage("This field only accepts images.");
                        }
                      }}
                    />
                    <span className="upload_image_holder">
                      <figure className="add_img">
                        <img src="/static/images/placeholder.png" alt="icon" />
                        <span className="upload_img_icon">
                          <img src="/static/images/edit2_icon.svg" alt="icon" />
                        </span>
                      </figure>
                    </span>
                  </label>
                )}
              </div>
              <div className="control_group w_33">
                <label>Upload Back Image</label>
                {image ? (
                  <div className="upload_image no_radius v2">
                    <div className="upload_image_holder">
                      <figure>
                        <CardMedia component="img" image={image} alt="photo" />
                      </figure>
                      <CloseIcon
                        onClick={() => {
                          setImage("");
                          setFileName("");
                        }}
                      />
                    </div>
                  </div>
                ) : (
                  <label
                    className="upload_image no_radius v2"
                    htmlFor="icon-button-file"
                  >
                    <Input
                      sx={{ display: "none" }}
                      id="icon-button-file"
                      type="file"
                      inputProps={{
                        accept: "image/png,image/jpeg",
                      }}
                      onChange={(event: ChangeEvent<HTMLInputElement>) => {
                        const files = (event.target as HTMLInputElement).files;
                        if (files && files[0].type.includes("image")) {
                          setFileName(files[0].name);
                          setImage(URL.createObjectURL(files[0]));
                        } else {
                          setAlertType(0);
                          setShowAlert(true);
                          setAlertMessage("This field only accepts images.");
                        }
                      }}
                    />
                    <span className="upload_image_holder">
                      <figure className="add_img">
                        <img src="/static/images/placeholder.png" alt="icon" />
                        <span className="upload_img_icon">
                          <img src="/static/images/edit2_icon.svg" alt="icon" />
                        </span>
                      </figure>
                    </span>
                  </label>
                )}
              </div>
            </div>
            <div className="form_btn">
              <Button
                className="btn btn_primary"
                onClick={() => navigate("/manage-employers")}
              >
                Save
              </Button>
            </div>
          </div>
        </CustomTabPanel>
      </div>
    </MainContainer>
  );
};

export default AddCustomer;
